module.exports = __webpack_public_path__ + "img/chris.07f1dba8.jpg";